import { Item } from "@/dto/item";
import { Merchant } from "@/dto/merchant";
import { redirect } from "next/navigation";
import {
  getFromSessionStorage,
  removeFromSessionStorage,
} from "./sessionStorageUtils";
import { GiftCardInfo } from "@/dto/giftCardInfo";
import { SessionStorageKey } from "./storageKeys";
import { TFunction } from "@/types";
import { ROUTE_GIFTCARD } from "./constants";

export const GIFT_CARD_CATEGORY_ID = "GIFTCARD";

export const giftCardCategory = {
  id: GIFT_CARD_CATEGORY_ID,
  name: "Gift Card",
  numberOfItems: 1,
  sortOrder: 0,
  items: ["GIFTCARD_ITEM"],
};

export const giftCardItem: Item = {
  id: "GIFTCARD_ITEM",
  name: "Digital Gift Card",
  options: [],
  price: 0,
  modifierGroupIds: [],
  categoryIds: [giftCardCategory.id],
  taxIds: [],
  images: [],
  available: true,
  serviceItem: [],
  modifiedTime: Date.now(),
  isAgeRestricted: false,
};

export const getGiftCardCategory = (t?: TFunction) => ({
  id: GIFT_CARD_CATEGORY_ID,
  name: t?.("giftCard") ?? "Gift Card",
  numberOfItems: 1,
  sortOrder: 0,
  items: ["GIFTCARD_ITEM"],
});

export const getGiftCardItem = (t?: TFunction) => ({
  id: "GIFTCARD_ITEM",
  name: t?.("digitalGiftCard") ?? "Digital Gift Card",
  options: [],
  price: 0,
  modifierGroupIds: [],
  categoryIds: [GIFT_CARD_CATEGORY_ID],
  taxIds: [],
  images: [],
  available: true,
  serviceItem: [],
  modifiedTime: Date.now(),
  isAgeRestricted: false,
  itemUrl: ROUTE_GIFTCARD,
});

/**
 * @deprecated This method is replaced by Merchant.isStandaloneGiftCardWebsite
 */
export const isStandaloneGiftCardWebsite = (
  merchant?: Merchant | null
): boolean => {
  if (!merchant) {
    return false;
  }
  return merchant?.isSellingGiftCards && merchant?.services?.length === 0;
};

export const redirectStandaloneGiftCard = (merchant: Merchant) => {
  if (merchant.isStandaloneGiftCardWebsite) {
    redirect(ROUTE_GIFTCARD);
  }
};

export const removeGiftCardInfo = () => {
  const giftCard = getFromSessionStorage<GiftCardInfo | null>(
    SessionStorageKey.GIFT_CARD_INFO,
    null
  );
  if (giftCard) {
    removeFromSessionStorage(SessionStorageKey.GIFT_CARD_INFO);
  }
};

export const GIFT_AMOUNT_MIN = 5;
export const GIFT_AMOUNT_MAX = 500;
export const GIFT_AMOUNT_DEFAULT = 10;
